import type { ReactNode } from 'react';

/** Panel with a bordered header: the one section-card pattern. */
export function SectionCard({
  title,
  count,
  actions,
  children,
  bodyClassName = 'p-4',
}: {
  title: ReactNode;
  count?: number;
  actions?: ReactNode;
  children: ReactNode;
  bodyClassName?: string;
}) {
  return (
    <section className="card overflow-hidden">
      <div className="flex items-center justify-between gap-3 border-b border-line px-4 py-3">
        <h2 className="text-sm font-semibold text-ink">
          {title}
          {typeof count === 'number' && (
            <span className="ml-1.5 text-xs font-normal text-ink-faint">{count}</span>
          )}
        </h2>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      <div className={bodyClassName}>{children}</div>
    </section>
  );
}
